<template>
  <lazy-app-dialog
    v-if="isOpen"
    v-model="isOpen"
    :header="false"
    :width="870"
    @close="acknowledge"
  >
    <div class="grid gap-8 md:grid-cols-[55%_1fr]">
      <div class="order-2 md:order-1">
        <h2 class="mb-3 text-2xl/snug font-extrabold">
          Vous êtes RH ?<br />
          Rejoignez le Club RH de Pollen
        </h2>

        <p class="text-subtle mb-6">
          Une communauté de décideurs RH qui souhaitent préparer leurs équipes
          aux défis de demain.
        </p>

        <ul class="text-subtle grid gap-3">
          <li v-for="item in list" :key="item.icon" class="flex gap-3">
            <app-icon
              class="bg-primary-100 text-primary rounded p-1"
              :icon="item.icon"
              :size="32"
            />
            <p v-html="item.label" />
          </li>
        </ul>

        <growth-contact-button
          block
          class="mt-8"
          color="primary"
          origin="hr_club_dialog"
          origin_page_action="hr_club_apply_cta"
          size="lg"
          @click="acknowledge"
        >
          Rejoindre le club
        </growth-contact-button>
      </div>

      <app-image
        alt=""
        class="order-1 aspect-[2.3] h-full rounded-xl object-cover md:order-2 md:aspect-auto"
        src="https://res.cloudinary.com/dfdgwwkpd/image/upload/v1732715804/brand/events/69fe0efe163acfdc1eeb6a4ba3c7a247_nt2lfv.jpg"
        :width="800"
      />
    </div>
  </lazy-app-dialog>
</template>

<script lang="ts" setup>
const DIALOG_AUTO_SHOW_DELAY_IN_MS = 8000;

const list: { label: string; icon: string }[] = [
  {
    icon: "ph:graduation-cap-duotone",
    label:
      "Participez à une <strong>session Pollen offerte</strong> (valeur : 490 €HT), sur validation de votre profil.",
  },
  {
    icon: "ph:handshake-duotone",
    label: "Échangez <strong>entre pairs</strong> sur vos enjeux RH actuels.",
  },
  {
    icon: "ph:ticket-duotone",
    label:
      "Recevez des invitations à nos <strong>événements exclusifs</strong>.",
  },
];

const { me } = useCurrentUser();
const [isOpen, toggle] = useToggle();
const { hasCompletePII } = useGrowthContact();
const { hasActiveDialog } = useActiveDialogs();

const hrClubDialogAcknowledged = useCookie("hr_club_dialog_acknowledged", {
  maxAge: 60 * 60 * 24 * 7,
  default: () => false,
});

function acknowledge() {
  hrClubDialogAcknowledged.value = true;
  toggle(false);
}

const route = useRoute();

const isBlacklistedForCurrentRoute = computed(() => {
  return (
    route.path.startsWith("/auth") ||
    route.path.startsWith("/assessment") ||
    route.name === "contact"
  );
});

if (import.meta.client && !hrClubDialogAcknowledged.value) {
  await timer(DIALOG_AUTO_SHOW_DELAY_IN_MS);

  if (
    !me.value &&
    !hasCompletePII.value &&
    !isBlacklistedForCurrentRoute.value &&
    !hasActiveDialog.value
  ) {
    toggle(true);
  }
}
</script>
